<template>
  <div class="kpi-row">
    <component
      :is="item.to ? 'router-link' : 'div'"
      v-for="(item, index) in items"
      :key="item.label"
      :to="item.to"
      class="kpi kpi-row__item">
      <div class="kpi__label">
        {{ item.label }}
      </div>
      <div class="kpi__value">
        {{ values[index] === null ? '…' : values[index].toLocaleString('fr-FR') }}
      </div>
      <div
        v-if="item.hint"
        class="kpi__hint">
        {{ item.hint }}
      </div>
    </component>
  </div>
</template>

<script>
  // Rangée de chiffres clés : chaque carte compte les éléments d'une ressource (count de l'API)
  export default {
    name: 'KpiRow',
    props: {
      // [{ label, resource, params, hint, to }]
      items: {
        type: Array,
        required: true
      }
    },
    data () {
      return {
        values: this.items.map(() => null)
      }
    },
    created () {
      this.items.forEach(async (item, index) => {
        try {
          const { data } = await this.$api.axios.get(item.resource, { params: { ...item.params, per_page: 1 } })
          this.$set(this.values, index, data.count || 0)
        } catch (e) {
          this.$set(this.values, index, 0)
        }
      })
    }
  }
</script>

<style scoped>
  .kpi-row {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 12px;
    margin-bottom: 18px;
  }
  .kpi-row__item {
    display: block;
    color: inherit;
    text-decoration: none;
    padding: 14px 18px;
  }
  a.kpi-row__item:hover {
    background: #f4f4f5;
  }
  .kpi-row__item .kpi__value {
    font-size: 24px;
  }
</style>
